import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const TooltipButton = ({ title, imgSrc, ...props }) => {
  const { placement, disabled } = props;
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      open={open && !disabled}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    >
      <IconButton aria-label={title} {...props}>
        <img src={imgSrc} />
      </IconButton>
    </Tooltip>
  );
};

export default TooltipButton;
